import Head from "next/head";
import { FunctionComponent } from "react";

import { Button, XSD, Video } from "@/components";

const About: FunctionComponent = () => (
  <>
    <Head>
      <title>BankX - About</title>
    </Head>
    <h1 className="column-3">About</h1>
    <section className="column-3 column-span-3 dense row-2">
      <p className="balance">
        The stablecoin, XSD, is designed to track the price of 1{" "}
        <strong>gram of silver</strong>.
      </p>
      <h2>How it works</h2>
      <p className="balance">
        The first <strong>silver-pegged</strong>, crypto-backed stablecoin that
        pays you interest where you never face liquidation.
      </p>
      <nav>
        <Button href="https://app.bankx.io/#/xsd">Learn More</Button>
      </nav>
    </section>
    <Video
      className="column-7 row-2"
      src="https://www.youtube.com/embed/LHl6I1zesyM?rel=0&amp;autoplay=1&mute=1"
    />
    <XSD className="column-3 row-3" />
  </>
);

export default About;
